import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, Form, Input, Label, Modal, ModalBody } from "reactstrap";
import { updateInfo } from "store/actions/authActions";

const RecommendedTeamatesModal = ({ isOpen, toggle }) => {
  const dispatch = useDispatch();
  const { user, uid } = useSelector((state) => state.auth);
  const initialTeamList = user.promoted_teammates
    ? [...user.promoted_teammates]
    : [""];
  const [teamList, setTeamList] = useState(initialTeamList);

  const handleTeamInputChange = (e, index) => {
    const { name, value } = e.target;
    const list = [...teamList];
    list[index] = value;
    setTeamList(list);
  };

  const handleRemoveClick = (index) => {
    const list = [...teamList];
    list.splice(index, 1);
    setTeamList(list);
  };

  const handleAddClick = () => {
    setTeamList([...teamList, ""]);
  };

  useEffect(() => {
    if (isOpen) {
      setTeamList(initialTeamList);
    }
  }, [isOpen]);

  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalBody>
        <Label className="auth-label">
          <b>Add Teammate ID to Recommend them:</b>{" "}
          <small className="text-danger">(Max-3)</small>
        </Label>
        <Form
          className="mt-3"
          onSubmit={(e) => {
            e.preventDefault();
            dispatch(updateInfo(uid, teamList, "teamList")).then((res) => {
              toggle();
            });
          }}
        >
          {teamList.length == 0 && (
            <div className="text-right">
              <Button onClick={handleAddClick} color="primary" size="md">
                <i className="fa fa-plus"></i>
              </Button>
            </div>
          )}
          {teamList.map((team, index) => (
            <div key={index}>
              <Label className="mt-3">Teammate #{index + 1}</Label>
              <div className="d-flex">
                <Input
                  required
                  className="mr-3"
                  name="teammate_id"
                  type="number"
                  placeholder="Enter Teammate ID"
                  defaultValue={team}
                  onChange={(e) => handleTeamInputChange(e, index)}
                />
                {teamList.length < 3 && (
                  <Button onClick={handleAddClick} color="primary" size="md">
                    <i className="fa fa-plus"></i>
                  </Button>
                )}
                {teamList.length > 0 && (
                  <Button
                    onClick={() => handleRemoveClick(index)}
                    color="danger"
                    size="md"
                  >
                    <i className="fa fa-minus"></i>
                  </Button>
                )}
              </div>
            </div>
          ))}
          <div className="text-right mt-5">
            <Button color="danger" onClick={toggle}>
              Close
            </Button>
            <Button color="primary" type="submit">
              Save
            </Button>
          </div>
        </Form>
      </ModalBody>
    </Modal>
  );
};

export default RecommendedTeamatesModal;
